export class Dialog
{
    static #dialog = document.querySelector('dialog');

    static init ()
    {
        this.#dialog.addEventListener('click', ({ clientX, clientY }) => {
            const { bottom, left, right, top } = this.#dialog.getBoundingClientRect();

            if (clientX < left || clientX > right || clientY < top || clientY > bottom) {
                this.#dialog.close();
            }
        });

        this.#dialog.querySelector('button').addEventListener('click', () => {
            this.#dialog.close();
        });

        document.querySelector('aside > button:nth-child(2)').addEventListener('click', () => {
            this.#dialog.showModal();
        });
    }
}
